// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ModifyMarketOrder } from '../order-modify/ModifyMarketOrder';
import { OrderTypeBase } from './OrderTypeBase';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { MarketOrderEdit } from '../order-edit/MarketOrderEdit';
export class MarketOrderType extends OrderTypeBase {
    constructor() {
        super(MarketOrderEdit, ModifyMarketOrder);
    }
    id() {
        return OrderType.Market;
    }
}
